import { render, staticRenderFns } from "./assurance_add.vue?vue&type=template&id=1b9c92a8&"
import script from "./assurance_add.vue?vue&type=script&lang=js&"
export * from "./assurance_add.vue?vue&type=script&lang=js&"
import style0 from "./assurance_add.vue?vue&type=style&index=0&id=1b9c92a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports